import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import naja from 'naja';
import netteForms from 'nette-forms';

export default class Menu {

    static init() {
        const menuMain = document.getElementById('jsMenuMain');
        const menuSpace = document.getElementById('jsMenuSpace');
        const searchWrapper = document.getElementById('jsSearchWrapper');
        const menuContainer = document.getElementById('jsMenuContainer');
        const topBar = document.getElementById('jsTopBar');
        const nav = document.getElementById('jsNav');

        let searchWrapperPB;
        // to 767px: set paddingBottom to menuMain as space for searchWrapper
        if (menuMain && searchWrapper && window.matchMedia('(max-width:767px)').matches) {
            searchWrapperPB = `${(30 + searchWrapper.offsetHeight) / 10}rem`;
            menuMain.style.paddingBottom = searchWrapperPB;
            // 30 = 15 padding bottom of .menu-main + 15 for top space above search
        }

        // set height to menuSpace (menuSpace hold real height on menuContainer in DOM object)
        if (menuContainer && menuSpace) {
            let height = menuContainer.offsetHeight;
            if (window.matchMedia('(min-width: 1280px)').matches && nav) {
                //height += nav.offsetHeight / 2;
            }
            menuSpace.style.height = `${height / 10}rem`;
        }

        // set scrolling
        if (menuContainer && menuMain && topBar && searchWrapper && nav) {
            Menu.setScroll(menuContainer, menuMain, topBar, searchWrapper, searchWrapperPB, nav);
        }

        // handle search
        if (searchWrapper) {
            Menu.handleSearch(searchWrapper);
        }

        // call menu handlers
        Menu.handleNav();
        Menu.handleNavLinks();
        Menu.handleSearchResult();
        Menu.handleDesktopHover();
    }

    /**
     * Set menuContainer behaviour on scrolling (but call on init too 'case diff position of user on load)
     * @param menuContainer
     * @param menuMain
     * @param topBar
     * @param searchWrapper
     * @param searchWrapperPB
     * @param nav
     */
    static setScroll(menuContainer, menuMain, topBar, searchWrapper, searchWrapperPB, nav) {
        let prevScrollPos = window.pageYOffset;
        let startMenuContainerPosition = topBar.offsetHeight + menuContainer.offsetHeight;
        let navHalfHeight = `-${(nav.offsetHeight / 2) / 10}rem`;
        const results = document.getElementById('jsSearchResult');
        let isMenuBottom = false;
        if (menuContainer.classList.contains('menu-container--bottom') && window.matchMedia('(max-width:1279px)').matches) {
            isMenuBottom = true;
        }

        function init() {
            let currentScrollPos = window.pageYOffset;

            // detect when "become to be fixed"
            if (startMenuContainerPosition * 2 <= currentScrollPos) {
                menuContainer.classList.add('menu-container--is-scrolled');
                menuMain.style.paddingBottom = '1.5rem';

                // set animation later 'cause better UX
                setTimeout(() => {
                    menuContainer.classList.add('menu-container--is-animated');
                }, 100);

                // default position of menu
                if (isMenuBottom) {
                    menuContainer.style.bottom = '0';
                } else {
                    menuContainer.style.top = '0';
                }

                // true: scroll direction is bottom, else: is top
                if (currentScrollPos > prevScrollPos) {
                    menuContainer.classList.remove('menu-container--is-scrolled-top');
                    if (results) {
                        results.classList.remove('search-result--open');
                    }
                    if (window.matchMedia('(min-width: 1280px)').matches) {
                        // rewrite default position of menu because navigation's height
                        if (!isMenuBottom) {
                            // menuContainer.style.top = navHalfHeight;
                        }
                    }
                } else {
                    menuContainer.classList.add('menu-container--is-scrolled-top');
                }

            } else {
                menuMain.style.paddingBottom = searchWrapperPB;

                menuContainer.classList.remove('menu-container--is-scrolled-top');
                menuContainer.classList.remove('menu-container--is-scrolled');
                menuContainer.classList.remove('menu-container--is-animated');
                searchWrapper.classList.remove('search__wrapper--open');
            }

            prevScrollPos = currentScrollPos;
        }

        // show menu on load
        init();
        window.onscroll = function () {
            // init menu on load
            init();
        };
    }

    /**
     * Toggle search click available on mobile
     * @param searchWrapper
     */
    static handleSearch(searchWrapper) {
        const searchTrigger = document.getElementById('jsSearchTrigger');
        const navToggle = document.getElementById('jsNavToggle');
        const navWrapper = document.getElementById('jsNavWrapper');

        if (searchTrigger) {
            searchTrigger.addEventListener('click', () => {
                if (window.matchMedia('(max-width:1279px)').matches) {
                    if (searchWrapper.classList.contains('search__wrapper--open')) {
                        enableBodyScroll(navWrapper);
                    } else {
                        if (navToggle.classList.contains('nav-toggle--open')) {
                            navToggle.click();
                        }
                        disableBodyScroll(navWrapper);
                    }
                }
                searchWrapper.classList.toggle('search__wrapper--open');
            });
        }


        const searchField = document.getElementById('searchField')
        const submitButton = document.getElementById('searchSubmit');
        if(submitButton && searchField) {
            submitButton.addEventListener('click', function(e) {
                location.href = '/vysledky-hledani/'+ encodeURIComponent(searchField.value);
            })
        }

    }

    /**
     * Toggle submenu on nav link's click on mobile
     */
    static handleNavLinks() {
        const navLinks = document.querySelectorAll('.jsNavLink');
        if (navLinks.length > 0 && window.matchMedia('(max-width:1280px)').matches) {
            navLinks.forEach((link) => {
                //let arrow = link.querySelector('.nav__link-title-arrow');
                //if (arrow) {
                    link.addEventListener('click', e => {
                        // e.preventDefault();
                        // e.stopPropagation();
                        if (!e.target.classList.contains('nav__link-title-text')) {
                            link.classList.toggle('nav__link-title--open');
                            let submenu = link.nextElementSibling;
                            if (submenu) {
                                submenu.classList.toggle('nav__submenu--open');
                            }
                        }
                    });
                //}
            });
        }
    }

    /**
     * Handle navigation on mobile
     */
    static handleNav() {
        const toggle = document.getElementById('jsNavToggle');
        const nav = document.getElementById('jsNav');
        const navWrapper = document.getElementById('jsNavWrapper');
        const searchWrapper = document.getElementById('jsSearchWrapper');

        if (toggle) {
            toggle.addEventListener('click', () => {
                toggle.classList.toggle('nav-toggle--open');
                nav.classList.toggle('nav--open');
                if (nav.classList.contains('nav--open')) {
                    disableBodyScroll(navWrapper);
                    searchWrapper.classList.remove('search__wrapper--open');
                } else {
                    enableBodyScroll(navWrapper);
                }
            });
        }
    }

    /**
     * Handle search result
     */
    static handleSearchResult() {
        const field = document.getElementById('searchField');
        const results = document.getElementById('jsSearchResult');
        const navWrapper = document.getElementById('jsNavWrapper');
        const form = document.querySelector('#jsSearchWrapper form');

        if (field && results) {
            field.addEventListener('input', () => {
                if(field.value.length >= 2) {
                    naja.uiHandler.submitForm(form);
                    results.classList.add('search-result--open');
                    if (window.matchMedia('(max-width:1024px)').matches) {
                        disableBodyScroll(navWrapper);
                    }
                }
            });
            const cross = document.getElementById('jsSearchResultCross');
            cross.addEventListener('click', ()=> {
                results.classList.remove('search-result--open');
                if (window.matchMedia('(max-width:1024px)').matches) {
                    enableBodyScroll(navWrapper);
                }
            });
        }
    }

    static handleDesktopHover() {
        if (window.matchMedia('(min-width:1280px)').matches) {
            const navBody = document.querySelector('.nav-body');
            /*const links = document.querySelectorAll('.nav-body > .nav__link')*/

            if (navBody) {
                navBody.addEventListener('mouseover', e => {
                    setTimeout(() => {
                        // when navBody has hover class can active menu
                        navBody.classList.add('hover');
                    }, 300);
                });
                navBody.addEventListener('mouseleave', e => {
                    navBody.classList.remove('hover');
                    // for sure ('cause fast hover over menu)
                    setTimeout(() => {
                        navBody.classList.remove('hover');
                    }, 300);
                });
            }

            /*if (links.length > 0) {
                links.forEach(link => {
                    link.addEventListener('mouseover', () => {
                        link.classList.add('hover');
                    })
                    link.addEventListener('mouseleave', e => {
                        setTimeout(() => {
                            link.classList.remove('hover');
                        }, 500);
                    })
                })
            }*/
        }
    }
}
